import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { FilterGroup } from 'data/filterGroup/filterGroup.types';

export enum FilterGroupMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newFilterGroup: FilterGroup = {
  id: '',
  fgId: '',
  name: '',
  owner: '',
  group: '',
  access: '',
};

export const filterGroupColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('filterGroup.grid.fgId'),
    field: 'fgId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'FTPID',
    flex: 1,
    minWidth: 274,
    maxWidth: 274,
  },
  {
    headerName: i18n.t('filterGroup.grid.name'),
    field: 'name',
    sortable: true,
    resizable: true,
    tooltipField: 'IPADDR',
    flex: 1,
    minWidth: 274,
    maxWidth: 274,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
];
